import { Rule, RuleGroup } from "csi/middleware/attributeRule/RuleStore";
import { FlexColumn, FlexRowCenter, OverflowText, Text } from "designSystem/index";
import { useLocale } from "designSystem/locale";
import React, { FC, ReactElement } from "react";
import dndCss from "designSystem/dnd/styles/dnd.module.css";
import css from "./CustomViewFilterGroupDragPreview.module.css";
import clsx from "clsx";

interface CustomViewFilterGroupDragPreviewProps {
	ruleGroup: RuleGroup;
}

export const CustomViewFilterGroupDragPreview: FC<CustomViewFilterGroupDragPreviewProps> = ({
	ruleGroup,
}): ReactElement => {
	const loc = useLocale();
	const attributesText = loc.resource("Attributes").toLocaleLowerCase();
	return (
		<FlexColumn
			className={clsx(dndCss.dragPreview, css.dragPreview)}
			justifyContent="center"
		>
			<FlexRowCenter gap={2} justifyContent="space-between">
				<FlexRowCenter>
					<Text noWrap text={`${ruleGroup.count} ${attributesText}`} />
				</FlexRowCenter>
				<OverflowText
					minWidth={0}
					noWrap
					text={ruleGroup.ruleItems.map((rule: Rule) => rule.item.name).join(", ")}
				/>
			</FlexRowCenter>
		</FlexColumn>
	);
};